module.exports = __webpack_public_path__ + "static/img/file.e5110f3b.png";